export const AngularGradient = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
      <g filter="url(#filter0_d_263_2791)">
        <path
          d="M12.2975 0.0302734L1.08337 3.9949L2.8555 18.7545L12.3093 23.9744L21.812 18.6838L23.5834 3.92469L12.2975 0.0302734Z"
          fill="#BEBECC"
        />
        <path
          d="M22.4648 4.77748L12.2712 1.2854V22.727L20.8139 17.9775L22.4648 4.77748Z"
          fill="url(#paint0_linear_263_2791)"
        />
        <path
          d="M2.3418 4.84051L3.86037 18.0407L12.2711 22.7271V1.28516L2.34189 4.84042L2.3418 4.84051Z"
          fill="url(#paint1_linear_263_2791)"
        />
        <path
          // eslint-disable-next-line max-len
          d="M15.0773 12.7L12.2713 14.0182H9.31387L7.92367 17.5114L5.33789 17.5594L12.2713 2.06421L15.0773 12.7001V12.7ZM14.806 12.0363L12.29 7.03241L10.2261 11.9502H12.2712L14.806 12.0364V12.0363Z"
          fill="white"
        />
        <path
          // eslint-disable-next-line max-len
          d="M12.2711 2.06396L12.2897 7.03225L14.6315 11.9539H12.2764L12.2711 14.0148L15.5277 14.0179L17.0497 17.5598L19.5239 17.6058L12.2711 2.06396Z"
          fill="#BEBECC"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_263_2791"
          x="-2.91663"
          y="0.0302734"
          width="30.5"
          height="31.9441"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_263_2791" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_263_2791" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_263_2791"
          x1="17.368"
          y1="22.727"
          x2="17.368"
          y2="1.2854"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF512F" />
          <stop offset="1" stopColor="#DD2476" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_263_2791"
          x1="2.3418"
          y1="12.0061"
          x2="12.2711"
          y2="12.0061"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DD2476" />
          <stop offset="1" stopColor="#FF512F" />
        </linearGradient>
      </defs>
    </svg>
  );
};
